import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormField } from '@nuso/forms/data-access';
import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-group-input',
    templateUrl: './group-input.component.html',
    styleUrls: ['./group-input.component.css'],
    standalone: false
})
export class GroupInputComponent extends BaseFormInput {
  @Input() override field: FormField;

}
